<template>
  <v-autocomplete
    :value="value"
    :items="itens"
    item-text="nome"
    item-value="id"
    item-disabled="desabilitado"
    :label="$t('Replicar_tambem_em')"
    :disabled="disabled || !perfilId"
    :hint="$t('Replicacao_perfil_ajuda')"
    persistent-hint
    prepend-inner-icon="mdi-domain-plus"
    multiple
    small-chips
    deletable-chips
    class="
      input-style
      font-size-input
      text-light-input
      placeholder-light
      input-icon
    "
    dense
    flat
    filled
    solo
    @input="$emit('input', $event)"
  >
    <template v-slot:prepend-item>
      <v-list-item
        ripple
        :disabled="!idsSelecionaveis.length"
        @mousedown.prevent
        @click="alternarTodos"
      >
        <v-list-item-action>
          <v-icon :color="value.length ? 'primary' : ''">
            {{ iconeTodos }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Todos_os_inquilinos") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2" />
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-action>
          <v-icon :color="attrs.inputValue ? 'primary' : ''">
            {{
              attrs.inputValue
                ? "mdi-checkbox-marked"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.nome }}</v-list-item-title>
          <v-list-item-subtitle v-if="item.documento">
            {{ item.documento }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="item.desabilitado">
          <v-chip
            x-small
            :color="item.vinculado ? 'success' : 'grey'"
            text-color="white"
          >
            {{ item.vinculado ? $t("Ja_vinculado") : $t("Indisponivel") }}
          </v-chip>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "PerfilReplicacaoInquilinosSelect",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    perfilId: {
      type: [String, Number],
      default: null,
    },
    // Itens de usuarios/{id}/perfis-replicacao já restritos aos inquilinos do usuário
    inquilinos: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itens() {
      return this.inquilinos.map((inquilino) => {
        const vinculado = this.contemPerfil(inquilino.idsPerfisVinculados);
        const permitido = this.contemPerfil(inquilino.idsPerfisDisponiveis);
        return {
          id: inquilino.id,
          nome:
            inquilino.fantasia || inquilino.razaoSocial || `#${inquilino.id}`,
          documento: inquilino.nRegistro || inquilino.nregistro || "",
          vinculado,
          desabilitado: vinculado || !permitido,
        };
      });
    },
    idsSelecionaveis() {
      return this.itens
        .filter((item) => !item.desabilitado)
        .map((item) => item.id);
    },
    todosSelecionados() {
      return (
        this.idsSelecionaveis.length > 0 &&
        this.idsSelecionaveis.every((id) => this.value.includes(id))
      );
    },
    iconeTodos() {
      if (this.todosSelecionados) {
        return "mdi-close-box";
      }
      return this.value.length ? "mdi-minus-box" : "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    // Ao trocar o perfil, descarta inquilinos que deixaram de ser selecionáveis
    idsSelecionaveis(ids) {
      const validos = this.value.filter((id) => ids.includes(id));
      if (validos.length !== this.value.length) {
        this.$emit("input", validos);
      }
    },
  },
  methods: {
    contemPerfil(ids) {
      return (
        Array.isArray(ids) &&
        this.perfilId !== null &&
        ids.some((id) => String(id) === String(this.perfilId))
      );
    },
    alternarTodos() {
      this.$emit(
        "input",
        this.todosSelecionados ? [] : [...this.idsSelecionaveis]
      );
    },
  },
};
</script>
